module.exports = __webpack_public_path__ + "media/newstyle/images/agbook-logo-mobile-2-5dbb3ecc73a72c7283eb3d9605885efb.jpg";